import { Box, Button, ButtonGroup } from '@chakra-ui/react';

import { usePlotMetricFromItem } from '../../hooks/usePlotMetric';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import type { PositionedItem } from '../PageConfigProvider/types/item';

type DisplayAsSelectorProps = {
  item: PositionedItem;
  isDisabled?: boolean;
};

export const DisplayAsSelector = ({
  item,
  isDisabled = false,
}: DisplayAsSelectorProps) => {
  const { dispatch } = useTabContentConfig();
  const metric = usePlotMetricFromItem(item);
  const id = item?.id;

  const isSegmentedHeadcountLine =
    item?.plot?.chartType === 'line' &&
    metric === 'headcount' &&
    !!item?.plot?.secondaryDimension &&
    item.plot.secondaryDimension !== 'timeseries';

  const defaultDisplayAs = isSegmentedHeadcountLine ? 'share' : 'value';
  const displayAsRaw = item?.plot?.displayAs ?? defaultDisplayAs;
  const displayAs = displayAsRaw === 'share' ? 'share' : 'value';

  const handleDisplayAsChange = (newDisplayAs: 'value' | 'share') => {
    if (id && displayAs !== newDisplayAs) {
      dispatch({
        type: 'UPDATE_ITEM_DISPLAY_AS',
        payload: { id, displayAs: newDisplayAs },
      });
    }
  };

  return (
    <Box marginBottom="1.5rem">
      <ButtonGroup
        size="sm"
        isAttached
        variant="outline"
        isDisabled={isDisabled}
      >
        <Button
          colorScheme={displayAs === 'value' ? 'green' : 'gray'}
          variant={displayAs === 'value' ? 'solid' : 'outline'}
          onClick={() => handleDisplayAsChange('value')}
          flex={1}
        >
          Absolute Value
        </Button>
        <Button
          colorScheme={displayAs === 'share' ? 'green' : 'gray'}
          variant={displayAs === 'share' ? 'solid' : 'outline'}
          onClick={() => handleDisplayAsChange('share')}
          flex={1}
        >
          Percentage Share
        </Button>
      </ButtonGroup>
    </Box>
  );
};
